<template>
    <Collapse v-if="list.length">
        <template slot="title">
            {{tab == SectionTabs.GROUP ? t('selectMember.group') : t('selectMember.groupMember')}}
        </template>
        <template slot="content">
            <GroupNode 
                v-for="(item, index) in list"
                :data="item"
                :key="index"
                :withMembers="withMembers"
                @handleExpand="handleExpand"
                @handleChecked="handleChecked"/>
            <Load v-if="hasMore" 
                :hasData="!!list.length"
                :hasMore="hasMore"
                :loading="loading" 
                @on-load="handleSearch"/>
        </template>
    </Collapse>
</template>
<script>
import Mixin from './mixin';
import { getGroupList, getGroupMemberList } from '../utils'
import GroupNode from '../section/section-group-node';

export default {
    name: "SearchGroupResult",
    mixins: [ Mixin ],
    components: {
        GroupNode
    },
    computed: {
        withMembers() {
            return this.tab === this.SectionTabs.GROUP_MEMBER;
        }
    },
    data() {
        return {}
    },
    methods: {
        handleSearch() {
            this.loading = true;
            const { host, qzId, keyword, language, token } = this.root
            return getGroupList(host, qzId, {
                keyword: keyword,
                page: this.page,
                size: this.size,
                language: language,
                token: token
            }).then(res => {
                let data = res.data
                if(!Array.isArray(data)) throw new Error();
                data.forEach(item => {
                    item.checked = false;
                    item.expand = false;
                    item.loading = false;
                    item.children = [];
                })
                this.list = this.list.concat(data);
                this.page ++;
                this.hasMore = data.length >= this.size;
            }).catch(err => {
                this.list = [];
                this.hasMore = true;
            }).finally(() => {
                this.loading = false;
            })
        },
        getMemberList(groupId, params, isSelect) { // 拉取当前内部群成员
            params && (params.loading = true)
            const { host, qzId, language, security, token } = this.root
            getGroupMemberList(host, qzId, groupId, {
                keyword: '',
                page: 1,
                size: 0,
                language: language,
                security: security,
                tmp: new Date().valueOf(),
                token: token,
                includeDuty: true
            }).then(res => {
                let data = res.data || []
                data.forEach(item => {
                    item.checked = !!isSelect || false;
                    if(isSelect) {
                        this.root.handleSelected(item)
                    }
                })
                params && (params.loading = false)
                params && (params.children = data)
            }).catch(error => {
                params.loading = false
            })
        },
        handleExpand(expand, data) {
            data.expand = expand;
            if (data.children && data.children.length) return;
            this.getMemberList(data.gid, data)
        },
        handleChecked(checked, data) {
            if(data.loading) return false
            if(!this.withMembers || data.type === 0) {
                if(checked && 1 + this.root.selectedCount > this.root.limit && this.root.limit != 1) {
                    Message.warning(t('selectMember.maximum'))
                    return false
                }
                data.checked = checked
                this.root.handleSelected(data)
                return true
            } 
            if(checked && data.groupMemberCount + this.root.selectedCount > this.root.limit) {
                Message.warning(t('selectMember.maximum'))
                return false
            }
            if(data.children && data.children.length) {
                data.checked = checked
                data.children.forEach((item)=>{
                    item.checked = checked
                    this.root.handleSelected(item)
                })
                return true
            }
            data.expand = true
            this.getMemberList(data.gid, data, true)
            return true
        },
    }
}
</script>